import React from "react";

function Location() {
  return (
    <div className="location-wrapper">
      <iframe
        className="location-map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2935.7094447707464!2d21.0862613!3d42.6251178!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1353620ceaca3503%3A0xc8bd55f16afc3f89!2sMETAL%20TEKNIKA%20ASLLANI!5e0!3m2!1sen!2s!4v1768381028845!5m2!1sen!2s"
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="location"
      ></iframe>
    </div>
  );
}

export default Location;
